export const OPEN_SIDEBAR_NAV = '[UI] OPENED SIDE BAR';
export const DISMISS_SIDEBAR_NAV = '[UI] DISMISSED SIDE BAR';

export default {
  OPEN_SIDEBAR_NAV,
  DISMISS_SIDEBAR_NAV,
};
